﻿import document from 'document';

export const handleKeyInput = () => {
  
    const keyCodes = {
        space: 32
    };
    const selectors = {
        emailField: '.form[data-component="form"] input.js-email-field'
    };

    const addDisableKeyHandler = (event, keyCode) => {
        const key = event.keyCode;
        if (key === keyCode) {
            event.preventDefault();
        }
    };

    const handleEmailFields = () => {
        const emailFields = [...document.querySelectorAll(selectors.emailField)];

        emailFields.forEach(field => {
            field.addEventListener('keypress', function ( event ) {  
                addDisableKeyHandler(event, keyCodes.space)
            });
        });
    }

    const init = () => {
        handleEmailFields();
    };

    return {
        init: init,
    };
};
